import { http, URL } from "./http.service";

export const initializePermissions = async (businessUuid) => {
  return await http.get(`${URL}/roles/initialize`, { businessUuid });
};

export const getAllRolePermissions = async (businessUuid) => {
  return await http.get(`${URL}/roles/${businessUuid}`);
};

export const getUserAllowedRoutes = async (businessUuid) => {
  return await http.get(`${URL}/roles/${businessUuid}/allowed-routes`);
};

export const updateRolePermissions = async (
  role,
  permissions,
  businessUuid
) => {
  return await http.put(`${URL}/roles/updaterole`, {
    role,
    permissions,
    businessUuid,
  });
};
